<template>
  <div id="login" style="min-height: 65.4vh;">
    <div class="bac">
      <div class="topHead">
        <div class="regist0">修改密码</div>
        <div class="register">
          <div class="rleft">没有账号？</div>
          <div class="rright" @click="register()">
            <router-link class="rright" to="/register">立即注册</router-link>
          </div>
        </div>
      </div>

      <div class="head" style="margin-bottom: 20px">
        <div class="sub">
          <div class="sub111">
            <span
              class="infoIcon subtopimg"
              :class="step >= 0 ? 'selectTitleColor' : 'defaultTitleColor'"
            >
             <i class="el-icon-user"></i>
            </span>
            <div
              class="subtop2"
              :class="step >= 0 ? 'selectTitleColor' : 'defaultTitleColor'"
            >
              验证用户名
            </div>
          </div>

          <div class="sub111">
            <div
              class="headLine"
              :class="step >= 0 ? 'selectColor' : 'defaultColor'"
            ></div>
            <div
              class="headCir"
              :class="step >= 0 ? 'selectColor' : 'defaultColor'"
            ></div>
          </div>
        </div>
        <div class="sub">
          <div class="sub111">
            <span
              class="infoIcon subtopimg"
              :class="step >= 1 ? 'selectTitleColor' : 'defaultTitleColor'"
            >
              <i class="el-icon-lock"></i>
            </span>
            <div
              class="subtop2"
              :class="step >= 1 ? 'selectTitleColor' : 'defaultTitleColor'"
            >
              验证码
            </div>
          </div>

          <div class="sub111">
            <div
              class="headLine"
              :class="step >= 1 ? 'selectColor' : 'defaultColor'"
            ></div>
            <div
              class="headCir"
              :class="step >= 1 ? 'selectColor' : 'defaultColor'"
            ></div>
          </div>
        </div>

        <div class="sub">
          <div class="sub111">
            <span
              class="infoIcon subtopimg"
              :class="step >= 2 ? 'selectTitleColor' : 'defaultTitleColor'"
            >
              <i class="el-icon-lock"></i>
            </span>
            <div
              class="subtop2"
              :class="step >= 2 ? 'selectTitleColor' : 'defaultTitleColor'"
            >
              修改密码
            </div>
          </div>

          <div class="sub111">
            <div
              class="headLine"
              :class="step >= 2 ? 'selectColor' : 'defaultColor'"
            ></div>
            <div
              class="headCir"
              :class="step >= 2 ? 'selectColor' : 'defaultColor'"
            ></div>
          </div>
        </div>
      </div>
      <div v-show="step == 0">
        <div class="item">
          <div class="left">您的用户名：</div>
          <input
            class="inputBac"
            placeholder="请输入用户名"
            v-model="account"
          />
        </div>
        <div class="item" v-if="type === 0">
          <div class="left">验证码：</div>
          <input
            class="inputBac"
            placeholder="请输入验证码"
            v-model="captchaCode"
          />
          <div
            :style="
              'background-image:url(' +
              verifyCodeImg +
              ');background-repeat:no-repeat;'
            "
            v-if="verifyCodeImg"
            class="codeimg"
            @click="captchaData"
          ></div>
          <div
            class="verifyCodeImg getCode"
            v-if="!verifyCodeImg"
            @click="captchaData"
          >
            <img src="../../static/img/refresh.png" class="refimg" />
            重新获取
          </div>
        </div>

        <!-- 行为校验  树莓 -->
        <div
          v-if="type === 2"
          id="captcha"
          class="loginBtn captchaStyle"
          @click="captchaClick"
        >
          {{ captchaText }}
        </div>
        <!--  行为验证 急眼 -->
        <div v-if="type === 1" id="captcha4" class></div>

        <div class="getCode" v-if="errorCode" @click="getDefaultStatus">
          <img src="../../static/img/refresh.png" class="refimg" />
          重新获取
        </div>
      </div>

      <div v-show="step == 1">
        <div class="item">
          <div class="left" style="width: 100px">
            <span style="color: #ff0000">*</span>用户名：
          </div>
          <input
            class="inputBac"
            style="width: 160px; margin-right: 10px"
            readonly
            :value="account"
          />
        </div>
        <div class="item">
          <div class="left" style="width: 100px">
            <span style="color: #ff0000">*</span>验证码：
          </div>
          <input
            class="inputBac"
            style="width: 160px; margin-right: 10px"
            placeholder="请输入验证码"
            v-model="smsCode"
          />
          <div class="phoneCode" @click="sendSmsCode">
            {{ sendSmsCodeTitle }}
          </div>
        </div>
      </div>

      <div v-show="step == 2">
        <div class="item">
          <div class="left"><span style="color: #ff0000">*</span>密码：</div>
          <input class="inputBac" v-model="pwd" />
          <!-- <div class="inputSub">6-15位小写字母或数字</div> -->
        </div>

        <div class="item">
          <div class="left">
            <span style="color: #ff0000">*</span>确认密码：
          </div>
          <input class="inputBac" v-model="confirmPwd" />
          <div class="inputSub">必须与登录密码一致</div>
        </div>
      </div>

      <div class="forgetbottomBtn" style="margin-top: 20px" @click="next()">下一步</div>

      <div
        @click="getCustomer"
        style="
          margin-top: 10px;
          margin-bottom: 50px;
          color: #333333;
          font-size: 12px;
        "
      >
        提示：需要修改密码，可以联系7X24h在线客服提供帮助
      </div>
    </div>
  </div>
</template>

<script>
import "./login.scss";
import gt from "../../utils/gt.js";
import "../../utils/smcp.min.js";

export default {
  data() {
    return {
      step: 0, //0输入账号，1手机验证码，2修改密码
      account: "",
      captchaCode: "",
      pwd: "",
      confirmPwd: "",
      verifyCodeImg: "--",
      smsCode: "",
      captchaKey: "",
      phone: "",
      memberId: "",
      codenum: 60,
      sendSmsCodeTitle: "发送验证码",
      type: 2, //行为校验2
      captcha: null, //行为校验
      captchaBox: null,
      captchaText: "",
      captchaMask: false,
      errorCode: false,
      smData:{
        lang: '',
        mode: '',
        organization: '',
        product: '',
        appId: '',         
        channel: '',       
      }
    };
  },
  mounted() {
    this.getDefaultStatus();
  },
  methods: {
    getCustomer() {
      //新旧客服判断
      if (window.customerServiceStatus == 1) {
        //新客服
        var obj = {};
        obj.host = this.$common.getHost();
        obj.clientCode = window.clientCode;
        obj.clientItem = window.childCode;
        obj.username =
          this.$common.getUser() && this.$common.getUser().username;
        obj.language = "zh_CN";
        obj.theme = "a018";
        obj.projectImgUrl = window.projectImgUrl;
        obj.orgin = window.location.origin + "/discounts";
        var str = JSON.stringify(obj);
        str = window.btoa(str);
        let url =
          this.$config.customerServiceUrl + "/customerService/pc?s=" + str;
        window.open(url, "_blank");
      } else {
        //旧客服
        const url = this.$common.getCustomerService();
        window.open(url, "_blank");
      }
    },
    // 获取   getDefaultStatus
    getDefaultStatus() {
      let _this = this;
      this.$http.get(this.$api.getDefaultStatus, false).then((res) => {
        if (res.code == 0) {
          // type   0：默认验证码  1：极验  2：数美"
          _this.type = res.data.type;
          // _this.type = 1;
          if (_this.type === 0) {
            //图片验证码
            //获取验证码图片
            this.captchaData();
          } else if (_this.type === 1) {
            //1：极验
            _this.disabled = false;
            _this.reset();
          } else if (_this.type === 2) {
            //2：数美"
            Object.assign(_this.smData,res.data);
            _this.reset();
          }
        } else {
          this.errorCode = true;
          this.type = null;
          this.moneyModeListReqSuccess = false;
          this.$message.error("加载失败，请重试");
        }
      });
    },
    //行为校验↓
    reset() {
      this.check();
      this.getCaptcha();
    },
    check() {
      if (this.captcha) {
        this.captchaText = "";
      } else {
        this.captchaText = "正在加载...";
      }
    },
    getCaptcha() {
      if (this.type == 1) {
        let _this = this;
        this.$http
          .get(this.$api.geetFirstRegister, "?t=" + window.childCode, false)
          .then((res) => {
            if (res.code == 0) {
              console.log(res, gt);
              window.initGeetest(
                {
                  gt: res.data.gt,
                  challenge: res.data.challenge,
                  new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                  offline: res.data.success === 1 ? false : true, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                  product: "float", // 产品形式，包括：float，popup
                  width: "100%",
                  lang: "cn",
                },
                _this.onCaptcha
              );
            } else {
              this.$message.error("获取错误");
            }
          });
      } else if (this.type == 2) {
        let data = {
          ...this.smData,
          width: 300,
          https: location.protocol == "https:"
        }
        initSMCaptcha(
          data,
          this.onCaptcha	 
        );
      }
    },
    onCaptcha(res) {
      //res是验证实例，可以调用res的示例方法
      var _this = this;
      this.captcha = res;
      console.log(this.captcha, "yyyyyyyyyyyyyyyyyyyyy");
      if (_this.type == 1) {
        res.appendTo("#captcha4");
        res.onReady(_this.check);
      } else if (this.type == 2) {
        this.captchaText = "点击验证";
        this.captcha.onSuccess(function (data) {
          if (data.pass) {
            _this.disabled = false;
            _this.captcha.rid = data.rid;
            _this.captchaText = "验证成功";
            _this.captchaMask = false;
          } else {
            _this.captcha.rid = null;
            _this.captchaText = "验证失败";
          }
        });

        this.captcha.onError(function (errType, errMsg) {
          _this.captcha.rid = null;
          _this.captchaText = "验证失败";
          _this.captchaMask = false;
        });

        this.captcha.onClose(function () {
          _this.captchaMask = false;
        });
      }
    },
    captchaClick() {
      if (this.type == 2) {
        var result = this.captcha.getResult();
        var pass = result.pass;
        if (!pass) {
          this.captcha.verify();
          //行为验证bug:点击关闭按钮，会点击穿透
          //解决：手动再添加一个遮罩层
          this.captchaMask = true;
        }
      }
    },
    captchaData: async function () {
      let _this = this;
      const res = await this.$http.get(_this.$api.captcha);
      if (res.code == 0) {
        _this.verifyCodeImg = res.data.captcha_image_content;
        // _this.captchaCode = res.data.captchaCode;
        _this.captchaKey = res.data.captchaKey;
      } else {
        // this.$message.error(res.msg + "");
      }
    },
    checkSmsCode() {
      return /^[0-9]{6}$/.test(this.smsCode);
    },
    checkPwd() {
      //return /^[a-zA-Z0-9]{6,15}$/.test(this.pwd);
      return this.pwd != "" ? true : false;
    },
    checkAccount() {
      var res = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/;
      if (
        this.account.length >= 4 &&
        this.account.length <= 16 &&
        res.test(this.account)
      ) {
        return true;
      } else {
        return false;
      }
    },
    next() {
      if (this.step == 0) {
        this.checkAccountAction();
      } else if (this.step == 1) {
        this.checkSmsCodeAction();
      } else {
        this.findPwd();
      }
    },

    async checkAccountAction() {
      let captcha4 = document.querySelector("#captcha4");
      var _this = this;
      let result = null;
      if (this.checkAccount() == false) {
        this.$message("请输入正确账号");
        return;
      }
      if (this.captchaCode.length == 0 && this.type === 0) {
        this.$message("请输入验证码");
        return;
      }

      if (_this.type != 0) {
        result = _this.captcha.getValidate();
        if (!result) {
          this.$message("请先通过行为验证");
          return;
        }
      }

      var params = {
        validateType: _this.type,
        name: _this.account,
      };

      //账号处理
      if (window.mergeAccount) {
        params.name = this.account + window.mergeAccount;
      }

      if (this.type === 0) {
        params.captchaKey = this.captchaKey;
        params.captchaCode = this.captchaCode;
      } else if (this.type === 1) {
        params.geeTestQueryVO = {
          challenge: result.geetest_challenge,
          seccode: result.geetest_seccode,
          validate: result.geetest_validate,
        };
      } else if (this.type === 2) {
        params.shuMeiQueryVO = {
          rid: result.rid,
        };
      }
      console.log(params);

      const res = await _this.$http.post(_this.$api.getMemberByName, params);
      if (res.code == 0) {
        _this.step = 1;
        // _this.phone = res.data.phone;
        _this.account = res.data.name
        _this.memberId = res.data.memberId;
      } else {
        _this.$message.error(res.msg + "");
        //重置行为校验
        if (_this.type === 1) {
          captcha4.innerHTML = "";
        }
        _this.getDefaultStatus();
      }
    },
    async sendSmsCode() {
      let _this = this;
      const res = await _this.$http.get(
        _this.$api.mobilebyacc,
        "/" + _this.account + '?functionId=2',
        true
      );

      if (res.code == 0) {
        this.inteval();
      } else {
        this.$message.error(res.msg);
      }
    },
    inteval() {
      var interval = setInterval(() => {
        --this.codenum;
        this.sendSmsCodeTitle = "重新发送" + "(" + this.codenum + "s" + ")";
      }, 1000);

      setTimeout(() => {
        clearInterval(interval);
        this.codenum = 60;
        this.sendSmsCodeTitle = "验证码";
      }, 60000);
    },
    async checkSmsCodeAction() {
      if (this.checkSmsCode() == false) {
        this.$message("请输入正确的手机验证码");
        return;
      }
      let _this = this;
      let params = {
        phone: this.phone,
        smsCode: this.smsCode,
      };
      console.log(params);

      const res = await _this.$http.post(_this.$api.checkSmsCode, params);
      if (res.code == 0) {
        _this.step = 2;
      } else {
        this.$message.error(res.msg + "");
      }
    },
    async findPwd() {
      if (this.checkPwd() == false) {
        this.$message("请输入密码");
        return;
      }
      if (this.pwd != this.confirmPwd) {
        this.$message("两次输入密码不一致");
        return;
      }

      let _this = this;
      let params = {
        code: this.smsCode,
        memberId: this.memberId,
        phone: this.phone,
        password: this.pwd,
      };
      console.log(params);

      const res = await _this.$http.post(
        _this.$api.resetMemberPwdByClient,
        params
      );
      if (res.code == 0) {
        _this.$message({
          message: "找回密码成功",
          type: "success",
        });
        _this.$router.push("/login");
      } else {
        this.$message.error(res.msg);
      }
      //
    },
  },
};
</script>

